import React from "react"
import * as Chakra from "@chakra-ui/react"
import {ResponsiveVideoImage} from "../video-image";

interface SideBySideImagesProps {
  images: { image: any, video_url?: string }[]
}

const SideBySideImages: PressLessComponent<SideBySideImagesProps> =
  React.forwardRef<HTMLDivElement, SideBySideImagesProps>(({ images }, ref) => {
    return (
      <Chakra.Box
        ref={ref}
        width="100%"
        display="flex"
        position="relative"
        alignItems="flex-start"
        flexDirection="column"
        backgroundColor="transparent"
      >
        <Chakra.Box
          width="100%"
          display="flex"
          maxWidth="1800px"
          alignItems="flex-start"
          marginLeft="auto"
          marginRight="auto"
          paddingLeft="40px"
          paddingRight="40px"
          flexDirection="column"
          css={{
            "@media (max-width: 767px)": {
              paddingLeft: "20px",
              paddingRight: "20px",
            },
          }}
          className="project-block"
        >
          <Chakra.Box
            width="100%"
            display="flex"
            flexWrap="wrap"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            {images &&
              images.map(({ image, video_url }) => (
                <ResponsiveVideoImage
                  key={image}
                  image={image}
                  width="calc(50% - 15px)"
                  //height="60vh"
                  objectFit="cover"
                  video_url={video_url}
                  wrapperProps={{
                   width: "calc(50% - 15px)",
                   css: {
                    "@media (max-width: 767px)": {
                      width: "100%",
                    },
                  }
                  }}
                  videoProps={{
                    width: "100%",
                  }}
                  css={{
                    "@media (max-width: 767px)": {
                      width: "100%",
                    },
                  }}
                />
              ))}
          </Chakra.Box>
        </Chakra.Box>
      </Chakra.Box>
    )
  })

SideBySideImages.displayName = "SideBySideImages"

SideBySideImages.pressless = {
  name: "Side By Side Images",
  attributes: {
    images: {
      name: "Images",
      type: "Repeater",
      attributes: {
        image: {
          name: "Image",
          type: "Image",
        },
        video_url: {
          name: "Video (URL)",
          type: "PlainText"
        }
      },
    },
  },
}

export default SideBySideImages
